import React from 'react';
import { withTranslation } from 'react-i18next';
import Header4 from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import About3 from '../Elements/About3';
import About2 from '../Elements/About2';
import WhatWeDo3 from '../Elements/WhatWeDo3';
import Statistics1 from '../Elements/Statistics1';
import Team1 from '../Elements/Team1';
import ClientsLogo1 from '../Elements/ClientsLogo1';

var bnrimg = require('../../images/banner/banner_about.jpg');

class Home4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        const { t } = this.props;
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title={t('pages.about.banner.title')} pagename={t('pages.about.banner.pagename')} description={t('pages.about.banner.description')} bgimage={bnrimg}/>
                    <About2 bgcolor="bg-gray" />
                    <About3 bgcolor="bg-gray" />
                    <WhatWeDo3 />
                </div>

                <Footer />
            </>
        );
    };
};

export default withTranslation()(Home4);